import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'associationsSupplier',
  pure: false
})
export class AssociationsSupplier implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (value &&  value.customer_supplier_ids.length) {
      return value.customer_supplier_ids.join(", ");
    }
    return "";
  }

}
